<script>
  import { sgettext } from '../i18n.js';

  export let name = sgettext('$$SAVE$$');
  export let sending = false;
  export let type = "primary";
  export let disabled = false;
  export let hidden = false;
  export let style = '';
  export let tooltip = false
</script>

<style>

</style>

<button
  data-tooltip={tooltip}
  type="button"
  {style}
  class="btn {`btn-${type}`} btn-icon {hidden? 'd-none' : ''}"
  disabled={disabled}
  on:click|preventDefault
  >
  <slot name="icon"></slot>
  <slot name="text">
    {name}
  </slot>

  {#if sending}
  <div class="spinner-border spinner-border-sm" role="status">
    <span class="sr-only">{sgettext('$$SENDING$$')}...</span>
  </div>
  {/if}
</button>
